import { LoaderFunctionArgs, defer, json, redirect } from "react-router-dom";

export interface INewAdvertisementLoaderData {}

export async function NewAdvertisementLoader({}: LoaderFunctionArgs) {
  return defer({} satisfies INewAdvertisementLoaderData);
}
